import React, { createContext, useState } from 'react';
import { Toast } from '@shopify/app-bridge-react';

export const ToastContext = createContext({
  toast: {
    text: null,
    isError: false
  },
  setToast: (value) => {}
});

const ToastProvider = (props) => {
  const [toast, setToast] = useState({
    text: null,
    isError: false
  });

  return (
    <ToastContext.Provider value={{toast, setToast}}>
      {(toast && toast.text) ? <Toast content={toast.text} error={toast.isError} onDismiss={() => { setToast() }}></Toast> : ''}
      {props.children}
    </ToastContext.Provider>
  )
};

export default ToastProvider;
